import { createSelector } from "reselect";
import get from "lodash/get";

const addressLookupDomain = state => get(state, "api.addressLookup.data", []);
const locationInfoDomain = state => get(state, "api.locationInfo.data", {});

export const addressLookupSelector = createSelector(
  addressLookupDomain,
  addressLookup => addressLookup
);

export const makeSelectPostalCodeOptions = () =>
  createSelector(addressLookupSelector, addressLookup => {
    return addressLookup.map(({ city, state, postal_code }) => {
      const label = `${city} ${state} ${postal_code}`;
      const value = `${city}-${state}-${postal_code}`;
      return { label, value };
    });
  });

  export const locationInfoSelector = createSelector(
    locationInfoDomain,
    locationData => locationData
  );
  
  export const makeSelectLocationInfo = () => locationInfoSelector;
